import * as React from 'react';

export const IconMenu = (props: React.SVGProps<SVGSVGElement>) => (
	<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
		<path fill="none" d="M0 0h24v24H0z" />
		<path fill="currentColor" d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
	</svg>
);
